import { UntypedFormGroup } from '@angular/forms';
import omit from 'lodash-es/omit';

import { isNullOrUndefined } from '@app/util/util';
import { AirBookingPayload, BookingArrangementVM, Travelers } from '@booking/entities/booking-arrangement';
import { BillingPayload, BillingResponse } from '@billing/entities/billing.payload';
import { createAt, payloadToCreate } from '@billing/mappers/billing-id.mapper';
import { BOOKING_FORM_INPUTS, TRAVELER_FORM_INPUTS } from '@booking/constants/forms.constants';
import { formatTravelerDate } from '@booking/mappers/traveler-date.mapper';
import { AssistanceBookPayload } from '@shared/travel-assistance/entities/booking-assistance';
import { assistanceBookPayload } from '@booking/mappers/assistance-search-payload.mapper';
import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { dobToDate } from '@ux/mappers/date.mapper';

export function airBookingPayloadMapper(
  form: UntypedFormGroup,
  ValidationId: string | string[],
  arrangement: BookingArrangementVM,
  billingInfo: BillingResponse,
  assistanceInfo: { optionId: number, searchId: string },
  travelerBookingProvider: TravelBookingType = TravelBookingType.FLIGHTS,
): AirBookingPayload {
  const isBySector = travelerBookingProvider === TravelBookingType.FLIGHTS_BY_SECTOR;
  const travelers = arrangement[BOOKING_FORM_INPUTS.TRAVELERS].map(traveler => {
    return {
      ...formatTraveler(traveler),
      DOB: formatTravelerDate(dobToDate(traveler.DOB)),
      RoomNumber: undefined,
      Phone: arrangement.Phone,
      Email: arrangement.Email
    };
  });
  const createIsEnabledByBilling = createAt(billingInfo);
  const createIsEnabledByAssistance = !isNullOrUndefined(assistanceInfo?.optionId);
  return {
    arrangement: {
      AdditionalInformation: form.value.Comments,
      ValidationId: isBySector ? undefined : ValidationId as string,
      ValidationIds: isBySector ? ValidationId as string[] : undefined,
      TravelItineraryId: 0,
      Travelers: travelers
    },
    billing: {
      createIsEnabled: createIsEnabledByBilling,
      payload: createIsEnabledByBilling ? payloadToCreate(billingInfo, arrangement) : {} as BillingPayload
    },
    assistance: {
      createIsEnabled: createIsEnabledByAssistance,
      payload: createIsEnabledByAssistance ?
        assistanceBookPayload(assistanceInfo?.searchId, travelers, assistanceInfo?.optionId) : {} as AssistanceBookPayload
    },
  };
}

function formatTraveler(traveler: Travelers): Travelers {
  const travelerName = `${traveler[TRAVELER_FORM_INPUTS.FIRST_NAME]} ${traveler[TRAVELER_FORM_INPUTS.SECOND_NAME]}`.trim();
  return omit({ ...traveler, [TRAVELER_FORM_INPUTS.FIRST_NAME]: travelerName },
    [
      TRAVELER_FORM_INPUTS.SECOND_NAME,
      TRAVELER_FORM_INPUTS.USER_ID,
      TRAVELER_FORM_INPUTS.INTERNATIONAL_DOCUMENT_REQUIRED
    ]);
}
